import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { colorSets } from '@swimlane/ngx-charts/release/utils';
import { customColorSets } from '../../../utils/custom-color-sets';

/**
 * Advanced donut component
 * @author Prasanth Venkatesan
 */
@Component({
  selector: 'neu-charts-donut-advanced',
  template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-advanced-pie-chart
        [view]="view"
        [scheme]="colorScheme"
        [results]="data"
        [gradient]="gradient"
        (select)="mSelectedEvent($event)">
        </ngx-charts-advanced-pie-chart>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
  styles: [`.chart-container{width:100%;height:100%}.chart-container /deep/ .total-value{font-size:1.4rem}.chart-container /deep/ .total-label{font-size:1.2rem}.chart-container /deep/ .legend-items{padding-top:10px}.chart-container /deep/ .legend-items .legend-item{line-height:1.4}.chart-container /deep/ .legend-items .legend-item:hover{opacity:.75}.chart-container /deep/ .legend-items .legend-item .item-value{font-size:1.2rem!important}.chart-container /deep/ .legend-items .legend-item .item-percent{font-size:1.1rem!important}`]
})
export class DonutAdvancedComponent implements OnInit {

    @Input('data') data: any[] = [];

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() { }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
